// extracted by mini-css-extract-plugin
module.exports = {"container":"index-module--container--3PBGS","indie":"index-module--indie--2aClL","casual":"index-module--casual--1gEOU"};